/**
 * Shared query keys for TanStack Query
 */
export const QUERY_KEYS = {
  CHATS: "chats",
  MCP_SERVERS: "MCP_SERVERS",
  SECRETS: "SECRETS",
  ENDPOINTS: "endpoints",
  TASKS: "TASKS",
  DEPLOYMENTS: "DEPLOYMENTS",
} as const;
